// extracted by mini-css-extract-plugin
export var alertBanner = "alertBanner-module--alertBanner--1Ru4G";
export var linkText = "alertBanner-module--linkText--1HNaK";
export var hide = "alertBanner-module--hide--1cCl6";